import IndividualAccountDrawer from './IndividualAccountDrawer'

export default IndividualAccountDrawer
